(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("FEGOVue"), require("FEGORender"), require("FEGOWebapi"));
	else if(typeof define === 'function' && define.amd)
		define(["FEGOVue", "FEGORender", "FEGOWebapi"], factory);
	else if(typeof exports === 'object')
		exports["/fego/component/live-info-card/render"] = factory(require("FEGOVue"), require("FEGORender"), require("FEGOWebapi"));
	else
		root["/fego/component/live-info-card/render"] = factory(root["FEGOVue"], root["FEGORender"], root["FEGOWebapi"]);
})(self, (__WEBPACK_EXTERNAL_MODULE__9666__, __WEBPACK_EXTERNAL_MODULE__5322__, __WEBPACK_EXTERNAL_MODULE__5113__) => {
return 